import React, { useEffect } from 'react'
import CalendarDayTag from './CalendarDayTag'
import PropTypes from 'prop-types'
import '../../assets/css/pages/calendar/calendar-day.css'
import _ from 'lodash'
import moment from 'moment'

//Note: The Overflow banner(lines 87-89) in this component works so long as the height of the tags and the height of the tag container doesn't change.

class CalendarDay extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      containerScrollTop: 0
    }
  }
  componentDidMount(){
    const element = document.getElementById('tag-container-' + this.props.day.isoString)
    element.addEventListener("scroll", ()=>{this.setScrollingNumber(element)})
  }

  componentWillUnmount(){
    const element = document.getElementById('tag-container-' + this.props.day.isoString)
    element.removeEventListener("scroll", ()=>{this.setScrollingNumber(element)})
  }

  setScrollingNumber(element){
    this.setState((state)=>{
      return {containerScrollTop: element.scrollTop}
    })
  }

  render() {
    const { day, assignments, selectedAssignments, setSelectedAssignment, isSelectedDate, numberOverflowing, selectedTagRef } = this.props
    let isSelectedAssignment = false
    const containerName = 'tag-container-' + day.isoString
    const orderedAssignments = _.isEmpty(assignments) ? [] : _.orderBy(assignments, grouping => {return grouping.assignments[0].orderingFingerprint})
    return (
      <div className={"calendar-day" + (day.isToday ? " current-day" : "") + (day.isCurMonth ? "" : " not-current-month")}>
        <div className='calendar-date'>
          <div className={"date-bubble" + (day.isWeekday ? "" : " weekend") + (isSelectedDate ? " selected-day" : "")}>{day.number}</div>
        </div>
        <div id={containerName} className='child-container'>
          {_.map(orderedAssignments, (assignmentGrouping, index) => {
            isSelectedAssignment = ((assignmentGrouping.title + assignmentGrouping.assignedAt + assignmentGrouping.key) === (selectedAssignments.title + selectedAssignments.assignedAt + selectedAssignments.key))
            if (assignmentGrouping.title || assignmentGrouping.moduleId) { return <CalendarDayTag key={index} assignment={assignmentGrouping} isSelectedAssignment={isSelectedAssignment} setSelectedAssignment={setSelectedAssignment} selectedTagRef={isSelectedAssignment ? selectedTagRef : undefined} /> }
          })}
        </div>
        { orderedAssignments.length > 3 && this.state.containerScrollTop === 0 &&
          <div className="day-overflow">{(orderedAssignments.length - 3) + ' More'}</div>
        }
      </div>
    )
  }
}

CalendarDay.propTypes = {
  day: PropTypes.object.isRequired
}

export default CalendarDay
